












































import { Component, Vue } from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import shortid from 'shortid';
import { PathViewModel, Path } from '@/features/bots/models/designer';
import PathDesigner from '../components/designer/PathDesigner.vue';
import {Action, Getter, Mutation} from 'vuex-class';
import { SET_PATHS, ADD_PATH, SET_CURRENT_PATH } from '@/store/bot-designer/paths/mutationTypes';
import DragIcon from '@/shared/components/DragIcon.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import HelpIcon from 'vue-material-design-icons/HelpCircleOutline.vue';
import {LOAD_HOLIDAYS} from '@/store/holidays/actionTypes';
import {HolidayViewModel} from '@/features/bots/models/holidayViewModel';

@Component({
	components: {
		Draggable,
		PathDesigner,
		DragIcon,
		ErrorIcon,
		AddIcon,
		HelpIcon
	}
})
export default class FlowEditor extends Vue {
	@Getter public paths!: PathViewModel[];
	@Getter public currentPath!: Path;
	@Getter public firstPath!: PathViewModel;
	@Getter public isPathInvalid!: boolean;
	@Mutation(SET_PATHS) public setPaths: (paths: PathViewModel[]) => void;
	@Mutation(ADD_PATH) public addPath: (path: PathViewModel) => void;
	@Mutation(SET_CURRENT_PATH) public setCurrentPath: (id: string) => void;
	@Action(LOAD_HOLIDAYS) public loadHolidays: () => Promise<HolidayViewModel[]>;

	public async created() {
		// Holidays need to be loaded before trigger box opened
		await this.loadHolidays();
	}

	get reorderablePathList() {
		return this.paths.slice(1);
	}

	set reorderablePathList(value) {
		value.unshift(this.firstPath); // add the first path back onto the list
		this.setPaths(value);
	}

	public addNewPath() {
		const newPath = {
			id: `path-${shortid.generate()}`,
			name: `New Path`,
			states: [],
		} as PathViewModel;

		this.addPath(newPath);
		this.setCurrentPath(newPath.id);
	}

	public isPathActive(pathId: string): boolean {
		return this.currentPath && this.currentPath.id === pathId;
	}

}
